export default {
    LOAD_LANGUAGES (state, languages) {
        state.items = languages
    }
}